import { CardClient as SmartCardClient } from '@atlaskit/link-provider';

export const smartCardClient = new SmartCardClient();
